import { CwtApiEntity, CwtCrudContract, CwtModel, CwtProp } from "@cawita/core-front/api";
import { isEmptyOrNotSet, isset } from "@hints/utils/data";
import { differenceInIntYears } from "@hints/utils/date";
import { formatName } from "@shared/utils/string.utils";
import { getYear } from "date-fns";
import { Client } from "../client";
import { UnitSystem } from "../common/unit-system.model";

export enum TesterGender {
    MR = 'mr',
    MS = 'ms',
    OTHER = 'other',
    NO = 'no',
}

export enum TesterMorphology {
    SKINNY = 'skinny',
    MEDIUM = 'medium',
    FAT = 'fat',
}

export function TesterSearchMapper(search: string) {
    return ({
        or: [
            { login: { regexp: search } },
            { email: { regexp: search } }
        ]
    })
}

@CwtModel({ name: 'tester' })
@CwtCrudContract({ path: 'tester', searchMapper: TesterSearchMapper })
@CwtCrudContract({ path: 'for-machine/tester' , identifier:'for-machine' })
@CwtCrudContract({ path: 'for-manager/client/:clientId/tester', identifier: 'for-manager' })
export class Tester extends CwtApiEntity {
    @CwtProp({ ref: Client }) client: Client;
    @CwtProp() firstName?: string;
    @CwtProp() lastName?: string;
    @CwtProp() login: string;
    @CwtProp() gender: TesterGender;
    @CwtProp() email: string;
    @CwtProp() password: string;
    @CwtProp() birthYear: number;
    @CwtProp() weight: number; // kg
    @CwtProp() height: number; // cm
    @CwtProp() weightSystem: UnitSystem;
    @CwtProp() heightSystem: UnitSystem;
    @CwtProp() morphology: TesterMorphology; 

    public get age() {
        if(!isset(this.birthYear)) return null;
        return differenceInIntYears(getYear(new Date()), this.birthYear);
    }

    public get coercedGender() {
        if (this.gender === TesterGender.MS) return TesterGender.MS;
        return TesterGender.MR;
    }

    public get coercedMorphology() {
        if (!isset(this.morphology)) return TesterMorphology.SKINNY;
        return this.morphology;
    }

    public get coercedName() {
        if(isEmptyOrNotSet(this.lastName) && isEmptyOrNotSet(this.firstName)) return this.login;
        return formatName(this.firstName, this.lastName);
    }

    public get coercedIdentifiableName() {
        if(isEmptyOrNotSet(this.lastName) && isEmptyOrNotSet(this.firstName)) return this.login;
        return `${formatName(this.firstName, this.lastName)} (${this.login})`;
    }
}